export const resolvePosition = position => {
  switch (position) {
    case 'Left':
      return 'flex-start';
    case 'Centre':
      return 'center';
    default:
      return 'flex-end';
  }
};
export const resolveAlignment = alignment => {
  switch (alignment) {
    case 'Right':
      return 'right';
    case 'Centre':
      return 'center';
    default:
      return 'left';
  }
};
